<template>
  <ul class="list">
    <slot />
  </ul>
</template>

<script>

import { ContainerMixin } from 'vue-slicksort';

export default {
  name: 'PostFormMediaItems',
  mixins: [ContainerMixin],
};

</script>



// WEBPACK FOOTER //
// src/components/PostFormMediaItems.vue